import { render, staticRenderFns } from "./BlogsPage.vue?vue&type=template&id=7047ad5a&url=https%3A%2F%2Fvuejs.org"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"
import style0 from "./BlogsPage.vue?vue&type=style&index=0&id=7047ad5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports